<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TableRechte></TableRechte>
    </v-col>
  </v-row>
</template>

<script>
import TableRechte from '../tables/TableGenralRechte'

export default {
  name: 'Rechte',
  components: {TableRechte},
  data() {
    return {}
  },
  methods: {
    myMethod: function () {
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
